import { PropsWithChildren } from "react";

import { styled } from "@linaria/react";
import { match } from "ts-pattern";

import { withTheme, type PropsWithTheme } from "@gx/dls/theme";

import { CreateSourceStep } from "@/pages/sources/components/create/types";

interface CreateSourceModalWrapperProps {
  step: CreateSourceStep;
}

const Wrapper = withTheme(styled.div<PropsWithTheme & { $step: CreateSourceStep }>`
  display: flex;
  flex-direction: column;

  max-height: 720px;
  width: ${({ $step }) => {
    return match($step)
      .with(CreateSourceStep.SELECT, () => 900)
      .with(CreateSourceStep.CONFIGURE, () => 750)
      .exhaustive();
  }}px;

  background-color: ${({ theme }) => theme.color.background.primary};
  border: 0.5px solid ${({ theme }) => theme.color.border.primary};
  border-radius: 8px;
`);

const CreateSourceModalWrapper = ({
  children,
  step,
}: PropsWithChildren<CreateSourceModalWrapperProps>) => {
  return <Wrapper $step={step}>{children}</Wrapper>;
};

export default CreateSourceModalWrapper;
